module.exports = __webpack_public_path__ + "static/media/video.11ac87c4.svg";